import "./OpenTraderHelpDialog.scss";

export class OpenTraderHelpDialogController {

}
